import "./Vznikáme.css";
import { Helmet } from "react-helmet-async";
import { useIFrameHeight } from "../../../hooks/useiFrameHeight.js";
import { Button } from "@ceskastranaasocialu/komponenty";
import { useState, Activity } from "react";
import { useSearchParams } from "react-router-dom";
import begginingtitle from "../../../images/Titles/web_soucast_nadpis.webp";

export function VznikámeTitle() {
    return <></>;
}

export function VznikámeNotifikace() {
    return <></>;
}

export default function Vznikáme() {
    const membershipiFrameRef = useIFrameHeight("membership");
    const mladetroskyiFrameRef = useIFrameHeight("mladetrosky");
    const donationiFrameRef = useIFrameHeight("donations");

    const [url] = useSearchParams();
    const urlTab = url.get("tab");
    const [tab, setTab] = useState(urlTab === "mladetrosky" ? "mladetrosky" : urlTab === "donation" ? "donations" : "membership");

    return (
        <div id="beginningContent">
            <Helmet>
                <title>Chci být součástí! · ČSA</title>
                <meta name="description" content="ČSA je recesistická politická strana, jejíž cílem, pokud ti to ještě nedošlo, je naprostá asocializace společnosti a České republiky. Chození ven způsobilo války, neštěstí a zmar, proto tu jsou asociálové, aby vše napravili. HLAVNĚ TO PROBOHA NEBERTE VÁŽNĚ, JSME RECESISTI!" />
                <meta property="og:title" content="Chci být součástí! · ČSA" />
                <meta property="og:description" content="ČSA je recesistická politická strana, jejíž cílem, pokud ti to ještě nedošlo, je naprostá asocializace společnosti a České republiky. Chození ven způsobilo války, neštěstí a zmar, proto tu jsou asociálové, aby vše napravili. HLAVNĚ TO PROBOHA NEBERTE VÁŽNĚ, JSME RECESISTI!" />
                <meta property="og:image" content={`${process.env.PUBLIC_URL}/assets/banner.png`} />
                <meta property="og:url" content="https://www.asocialove.cz/pomoc/vznikame" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Chci být součástí! · ČSA" />
                <meta name="twitter:description" content="ČSA je recesistická politická strana, jejíž cílem, pokud ti to ještě nedošlo, je naprostá asocializace společnosti a České republiky. Chození ven způsobilo války, neštěstí a zmar, proto tu jsou asociálové, aby vše napravili. HLAVNĚ TO PROBOHA NEBERTE VÁŽNĚ, JSME RECESISTI!" />
                <meta name="twitter:image" content={`${process.env.PUBLIC_URL}/assets/banner.png`} />
            </Helmet>
            <div className="begginingTitle">
                <img src={begginingtitle} alt="" draggable="false"></img>
            </div>
            <div className="begginigContentWrapperTlačítka">
                <Button as="button" variant={tab === "membership" ? "primary" : "dark"} highlight onClick={() => setTab("membership")}>Přihláška do strany</Button>
                <Button as="button" variant={tab === "mladetrosky" ? "primary" : "dark"} highlight onClick={() => setTab("mladetrosky")}>Přihláška do Mladých Trosek</Button>
                <Button as="button" variant={tab === "donations" ? "primary" : "dark"} highlight onClick={() => setTab("donations")}>Ožebračení</Button>
            </div>
            <Activity mode={tab === "membership" ? 'visible' : 'hidden'}>
                <div id="beginningContentWrapperPřihláška">
                    <span className="sectionTitle">Přihláška do Strany</span>
                    <div className="vstupSeznam">
                        <div className="vstupKarta">
                            <span className="vstupCislo">01</span>
                            <span className="vstupText">musíš mít české občanství nebo být občan země EU s TRVALÝM bydlištěm v ČR</span>
                        </div>
                        <div className="vstupKarta">
                            <span className="vstupCislo">02</span>
                            <span className="vstupText">musí ti být alespoň 18 let</span>
                        </div>
                        <div className="vstupKarta">
                            <span className="vstupCislo">03</span>
                            <span className="vstupText">nesmíš být členem žádné politické strany</span>
                        </div>
                        <div className="vstupKarta">
                            <span className="vstupCislo">04</span>
                            <span className="vstupText">všechna komunikace probíhá na platformě Discord</span>
                        </div>
                        <div className="vstupKarta">
                            <span className="vstupCislo">05</span>
                            <span className="vstupText">Když se připojíš na Discord, jdi do sekce Chci se přidat do strany, vytvoř ticket a domluv se na pohovoru</span>
                        </div>
                        <div className="vstupKarta">
                            <span className="vstupCislo">06</span>
                            <span className="vstupText">Bude tě čekat pohovor</span>
                        </div>
                    </div>
                    <iframe ref={membershipiFrameRef} src="https://socializace.asocialove.cz/embed/membership" allowtransparency="true" title="Přihlašovací formulář do České Strany Asociálů" />
                </div>
            </Activity>
            <Activity mode={tab === "mladetrosky" ? 'visible' : 'hidden'}>
                <div id="beginningContentWrapperPřihláška">
                    <span className="sectionTitle">Přihláška do Mladých Trosek</span>
                    <div className="textPrihlaska">
                        <p>Už i ČSA má mládežnickou organizaci, která není omezená věkem, financemi, nebo něčím takovým. Aby ses mohl stát mladou troskou, tak musíš žít... A to je všechno! Realně ani členský příspěvek platit nemusíš. Všechna komunikace je na discordu (jak jinak), takže se do kontaktů dej nejlíp svůj discord nick.</p>
                    </div>
                    <iframe ref={mladetroskyiFrameRef} src="https://socializace.asocialove.cz/embed/mladetrosky" allowtransparency="true" title="Přihlašovací formulář do České Strany Asociálů" />
                </div>
            </Activity>
            <Activity mode={tab === "donations" ? 'visible' : 'hidden'}>
                <div id="beginningContentWrapperPřihláška">
                    <span className="sectionTitle">Ožebračení</span>
                    <div className="textPrihlaska">
                        <p>Až vyplníš údaje, na e-mail se ti pošle smlouva a QR kód. Ten QR kód naskenuj a tím nám pošleš peníze. Prosím, fakt je potřebujeme, náš rozpočet je doslova nedojedený vlašák a dva rohlíky.</p>
                    </div>
                    <iframe ref={donationiFrameRef} src="https://socializace.asocialove.cz/embed/donation" allowtransparency="true" title="Přihlašovací formulář do České Strany Asociálů" />
                </div>
            </Activity>
        </div>
    );
}